import { LibraryItemStatus, LibraryItemType } from '@business/entities/library';

export function getStatusLabel(status: LibraryItemStatus) {
  switch (status) {
    case LibraryItemStatus.public:
      return 'Public (Visible for customers and staff - can share a link with anyone)';
    case LibraryItemStatus.private:
      return 'Private (Only for Staff on GC)';
    case LibraryItemStatus.draft:
      return "Draft (I'm still writing it and only visible to Admins)";
  }
}

export function getAddEditItemModalTitle(type: LibraryItemType) {
  switch (type) {
    case LibraryItemType.howTo:
      return 'Procedure';
    case LibraryItemType.policy:
      return 'Policy';
    case LibraryItemType.job:
      return 'Job Description';
    case LibraryItemType.orgChart:
      return 'Org Chart';
    case LibraryItemType.flowChart:
      return 'Flow Chart';
    case LibraryItemType.folder:
      return 'Folder';
    case LibraryItemType.file:
      return 'Files';
    case LibraryItemType.custom:
      return 'Custom';
  }
}

export function getTypeByString(type: string) {
  switch (type) {
    case 'howTo':
      return LibraryItemType.howTo;
    case 'policy':
      return LibraryItemType.policy;
    case 'folder':
      return LibraryItemType.folder;
    case 'job':
      return LibraryItemType.job;
    case 'orgChart':
      return LibraryItemType.orgChart;
    case 'flowChart':
      return LibraryItemType.flowChart;
    case 'file':
      return LibraryItemType.file;
    case 'custom':
      return LibraryItemType.custom;
    default:
      return LibraryItemType.folder;
  }
}

export function getAllTypes() {
  return [
    // LibraryItemType.policy,
    // LibraryItemType.howTo,
    // LibraryItemType.job,
    LibraryItemType.orgChart,
    LibraryItemType.flowChart,
    LibraryItemType.file,
    LibraryItemType.folder,
  ];
}
